// extracted by css-extract-rspack-plugin
export default {"formContainer":"adH0I","buttonWrapper":"mNc3D","inputLabel":"N6I3W","row":"j42Sd","input":"dLDZZ","cancelButton":"HWenN","submitButton":"sQDwQ"};